import axios from '@/allotment/axios'

export default {
  loginPassword: (username, password) => axios.post('/login/password', { username, password }), //账号密码登录
  loginCode: (username, code) => axios.post('/login/code', { username, code }), //验证码登录
  sendCode: (toUser, yzmType) => axios.post('/mail/send', { toUser, yzmType }), //获取邮箱验证码
  forgot: data => axios.post('/user/find/password', data), //忘记密码
  register: data => axios.post('/user/register', data), //注册账号
  logout: () => axios.get('/login/out'), //退出登录

  loginUserInfo: data => axios.post('/user/update/basic', data), //修改登录用户信息
  loginUserPassword: data => axios.post('/user/update/password', data), //修改的登录用户密码
  loginUserUsername: data => axios.post('/user/update/account', data), //修改的登录用户账户
  loginUserCancel: () => axios.get('/user/cancel'), //注销账户
  loginCompanyInfo: () => axios.post('/company/get/myini'), //获取当前登录用户企业信息
  loginCompanySave: data => axios.post('/company/save', data) //保存当前登录用户企业信息
}